import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './login/login.component';
import { LogoutComponent } from './logout/logout.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { DriverComponent } from './drivers/driver/driver.component';
import { ModuleComponent } from './modules/module/module.component';
import { BridgeComponent } from './bridges/bridge/bridge.component';
import { SensorComponent } from './sensors/sensor/sensor.component';
import { SensorAccessoryComponent } from './sensor_accessories/sensor_accessory/sensor_accessory.component';
import { DrilldownComponent } from './drilldown/drilldown.component';
import { FamiliesEditComponent } from './families/edit/edit.component';
import { DrilldownListComponent } from './drilldown/list/list.component';
import { BatchEditModulesComponent } from './batch/modules/edit.component';
import { BatchEditDriversComponent } from './batch/drivers/edit.component';
import { BatchEditBridgesComponent } from './batch/bridges/edit.component';
import { BatchEditSensorsComponent } from './batch/sensors/edit.component';
import { BatchEditSensorAccessoriesComponent } from './batch/sensor-accessories/edit.component';
import { GenericsearchComponent } from './genericsearch/genericsearch.component';
import { ManagementComponent } from './management/management.component';
import { TagsDrilldownComponent } from './tags-drilldown/tags-drilldown.component';
import { TagComponent } from './tags-drilldown/tag/tag.component';
import { CccComponent } from './ccc/ccc.component';
import { AdminComponent } from './admin/admin.component';
import { AuthenticationService } from './_services';
import { WhitelistingComponent} from './management/components/whitelisting/whitelist.component';
import { OidcAuthenticateComponent } from './auth/oidc_authenticate.component';
import { AppComponent } from './app.component';
import { OidcSilentAuthenticateComponent } from './auth/oidc_silent_authenticate.component';

export const appRoutes: Routes = [

  { path: 'oidc-authenticate', component: OidcAuthenticateComponent },
  { path: 'oidc-silent', component: OidcSilentAuthenticateComponent },
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },
  { path: 'unauthorized', component: UnauthorizedComponent },

  { path: 'search', component: GenericsearchComponent, canActivate: [AuthenticationService] },
  { path: 'management', component: ManagementComponent, canActivate: [AuthenticationService] },
  { path: 'labels', component: TagsDrilldownComponent, canActivate: [AuthenticationService],
    children: [
      { path: 'family/:id', component: TagsDrilldownComponent, canActivate: [AuthenticationService] }
    ]
  },
  { path: 'labels/label/:id', component: TagComponent, canActivate: [AuthenticationService] },
  { path: 'labels/new-label/:familyId', component: TagComponent, canActivate: [AuthenticationService] },
  { path: 'ccc', component: CccComponent, canActivate: [AuthenticationService] },
  { path: 'whitelisting', component: WhitelistingComponent, canActivate: [AuthenticationService] },
  { path: 'admin', component: AdminComponent, canActivate: [AuthenticationService] },
  { path: 'drivers/driver', component: DriverComponent, canActivate: [AuthenticationService] },
  { path: 'modules/module', component: ModuleComponent, canActivate: [AuthenticationService] },
  { path: 'bridges/bridge', component: BridgeComponent },
  { path: 'sensors/sensor', component: SensorComponent, canActivate: [AuthenticationService] },
  { path: 'sensor-accessories/sensor-accessories', component: SensorAccessoryComponent, canActivate: [AuthenticationService] },
  { path: 'drilldown/:type', component: DrilldownComponent, canActivate: [AuthenticationService],
    children: [
      { path: '', component: DrilldownListComponent, canActivate: [AuthenticationService] },
      { path: 'family/:id', component: FamiliesEditComponent, canActivate: [AuthenticationService] },
      { path: 'new-family', component: FamiliesEditComponent, canActivate: [AuthenticationService] },
      { path: 'modules/:id', component: ModuleComponent, canActivate: [AuthenticationService] },
      { path: 'drivers/:id', component: DriverComponent, canActivate: [AuthenticationService] },
      { path: 'bridges/:id', component: BridgeComponent },
      { path: 'sensors/:id', component: SensorComponent, canActivate: [AuthenticationService] },
      { path: 'sensor-accessories/:id', component: SensorAccessoryComponent, canActivate: [AuthenticationService] },
      { path: 'batch/drivers/:list', component: BatchEditDriversComponent, canActivate: [AuthenticationService] },
      { path: 'batch/modules/:list', component: BatchEditModulesComponent, canActivate: [AuthenticationService] },
      { path: 'batch/bridges/:list', component: BatchEditBridgesComponent, canActivate: [AuthenticationService] },
      { path: 'batch/sensors/:list', component: BatchEditSensorsComponent, canActivate: [AuthenticationService] },
      { path: 'batch/sensor-accessories/:list', component: BatchEditSensorAccessoriesComponent, canActivate: [AuthenticationService] }

    ]},

  { path: '', component: AppComponent },
];

export const routing = RouterModule.forRoot(appRoutes, {
  useHash: true,
  initialNavigation: false,
});



// WEBPACK FOOTER //
// ./src/app/app.routing.ts